import './BottomPurchaseBar.css';

const BottomPurchaseBar = () => {
  return (
    <div className="bottom-purchase-bar">
        <button type="button" className="toggle-like">
            <img src="/bottom_like.svg" alt="좋아요"/>
            <span>찜하기</span>
        </button>
        <button type="button" className="purchase-product">구매하기</button>
    </div>
  );
};

export default BottomPurchaseBar;